module.exports = __webpack_public_path__ + "fonts/260c807.eot";